import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const BillingTransaction = React.lazy(() =>
    import('../BillingTransaction')
);
const billingTransactionRoutesRegistry = [
    {
        path: PAGE_URL.BILLING_TRANSACTION_PAGE,
        element: <BillingTransaction />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default billingTransactionRoutesRegistry;
